import api from '../services/api';

export const cleanArray = (arr) => {
  return arr.map((obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(
        ([_, value]) => value !== null && value !== '' && value !== undefined,
      ),
    ),
  );
};

export const cleanObject = (obj) => {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Array.isArray(obj)) {
    return obj
      .map(cleanObject) // Limpia cada objeto dentro del array
      .filter((item) => !(typeof item === 'object' && Object.keys(item).length === 0)); // Elimina objetos vacíos
  }

  return Object.fromEntries(
    Object.entries(obj)
      .map(([key, value]) => [key, cleanObject(value)]) // Limpia valores anidados
      .filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== '' &&
          !(Array.isArray(value) && value.length === 0), // Elimina arrays vacíos
      ),
  );
};

export const getFile = async (filePath) => {
  const response = await api.get(filePath, {
    responseType: 'blob',
  });

  return response.data;
};
